import CustomPopover from "components/Atoms/CustomPopover"
import React from "react"
import OutletInfoCard from "./OutletInfoCard"

import CustomMarkerPin from "components/Molecules/CustomMarkerPin"
const OutletMarker = ({
  marker,
  step = null,
  toggleSelect = null,
  index,
  disabled = false,
}) => {
  const isSelected = marker.sequence ? true : false

  const coOrdinates = {
    lat: marker?.address?.latitude,
    lng: marker?.address?.longitude,
  }
  const sequence = index + 1
  const label = sequence?.toString()

  return (
    <>
      <CustomMarkerPin
        label={label}
        onClick={
          disabled
            ? null
            : step === "select"
            ? () => toggleSelect(marker)
            : null
        }
        type={
          isSelected
            ? "selected"
            : marker?.routepoints?.length
            ? "secondary"
            : "default"
        }
        renderMarker={renderedMarker => {
          return (
            <CustomPopover
              interactionKind="hover"
              content={<OutletInfoCard outlet={marker} sequence={label} />}
            >
              {renderedMarker}
            </CustomPopover>
          )
        }}
        key={marker.id}
        position={coOrdinates}
      />
    </>
  )
}

export default OutletMarker
